const AmexCountryOptions = (list) => {
  const country = [
    {
      name: "Afghanistan",
      code: "AF",
    },
    {
      name: "Aland Islands",
      code: "AX",
    },
    {
      name: "Albania",
      code: "AL",
    },
    {
      name: "Algeria",
      code: "DZ",
    },
    {
      name: "American Samoa",
      code: "AS",
    },
    {
      name: "Andorra",
      code: "AD",
    },
    {
      name: "Angola",
      code: "AO",
    },
    {
      name: "Anguilla",
      code: "AI",
    },
    {
      name: "Antarctica",
      code: "AQ",
    },
    {
      name: "Antigua and Barbuda",
      code: "AG",
    },
    {
      name: "Argentina",
      code: "AR",
    },
    {
      name: "Armenia",
      code: "AM",
    },
    {
      name: "Aruba",
      code: "AW",
    },
    {
      name: "Australia",
      code: "AU",
    },
    {
      name: "Austria",
      code: "AT",
    },
    {
      name: "Azerbaijan",
      code: "AZ",
    },
    {
      name: "Bahamas",
      code: "BS",
    },
    {
      name: "Bahrain",
      code: "BH",
    },
    {
      name: "Bangladesh",
      code: "BD",
    },
    {
      name: "Barbados",
      code: "BB",
    },
    {
      name: "Belgium",
      code: "BE",
    },
    {
      name: "China",
      code: "CN",
    },
    {
      name: "Guinea",
      code: "GN",
    },
    {
      name: "Guinea-Bissau",
      code: "GW",
    },
    {
      name: "Guyana",
      code: "GY",
    },
    {
      name: "Haiti",
      code: "HT",
    },
    {
      name: "Heard Island and McDonald Islands",
      code: "HM",
    },
    {
      name: "Honduras",
      code: "HN",
    },
    {
      name: "Hong Kong",
      code: "HK",
    },
    {
      name: "Hungary",
      code: "HU",
    },
    {
      name: "Iceland",
      code: "IS",
    },
    {
      name: "India",
      code: "IN",
    },
    {
      name: "Indonesia",
      code: "ID",
    },
    {
      name: "Iraq",
      code: "IQ",
    },
    {
      name: "Ireland",
      code: "IE",
    },
    {
      name: "Isle of Man",
      code: "IM",
    },
    {
      name: "Malaysia",
      code: "MY",
    },
    {
      name: "Maldives",
      code: "MV",
    },
    {
      name: "Mali",
      code: "ML",
    },
    {
      name: "Malta",
      code: "MT",
    },
    {
      name: "Marshall Islands",
      code: "MH",
    },
    {
      name: "Martinique",
      code: "MQ",
    },
    {
      name: "Mauritania",
      code: "MR",
    },
    {
      name: "Mauritius",
      code: "MU",
    },
    {
      name: "Mayotte",
      code: "YT",
    },
    {
      name: "Mexico",
      code: "MX",
    },
    {
      name: "Micronesia (Federated States of)",
      code: "FM",
    },
    {
      name: "Moldova",
      code: "MD",
    },
    {
      name: "Monaco",
      code: "MC",
    },
    {
      name: "Mongolia",
      code: "MN",
    },
    {
      name: "Montenegro",
      code: "ME",
    },
    {
      name: "Montserrat",
      code: "MS",
    },
    {
      name: "Morocco",
      code: "MA",
    },
    {
      name: "Mozambique",
      code: "MZ",
    },
    {
      name: "Myanmar",
      code: "MM",
    },
    {
      name: "Namibia",
      code: "NA",
    },
    {
      name: "Nauru",
      code: "NR",
    },
    {
      name: "Nepal",
      code: "NP",
    },
    {
      name: "Netherlands",
      code: "NL",
    },
    {
      name: "Netherlands Antilles",
      code: "AN",
    },
    {
      name: "Rwanda",
      code: "RW",
    },
    {
      name: "Samoa",
      code: "WS",
    },
    {
      name: "San Marino",
      code: "SM",
    },
    {
      name: "Sao Tome and Principe",
      code: "ST",
    },
    {
      name: "Saudi Arabia",
      code: "SA",
    },
    {
      name: "Senegal",
      code: "SN",
    },
    {
      name: "Serbia",
      code: "RS",
    },
    {
      name: "Seychelles",
      code: "SC",
    },
    {
      name: "Singapore",
      code: "SG",
    },
    {
      name: "Sint Maarten",
      code: "SX",
    },
    {
      name: "Slovakia",
      code: "SK",
    },
    {
      name: "Slovenia",
      code: "SI",
    },
    {
      name: "Solomon Islands",
      code: "SB",
    },
    {
      name: "Somalia",
      code: "SO",
    },
    {
      name: "South Africa",
      code: "ZA",
    },
    {
      name: "South Georgia & South Sandwich",
      code: "GS",
    },
    {
      name: "Spain",
      code: "ES",
    },
    {
      name: "Sri Lanka",
      code: "LK",
    },
    {
      name: "St. Barthelemy",
      code: "BL",
    },
    {
      name: "St. Helena",
      code: "SH",
    },
    {
      name: "St. Kitts-Nevis",
      code: "KN",
    },
    {
      name: "St. Lucia",
      code: "LC",
    },
    {
      name: "St. Martin",
      code: "MF",
    },
    {
      name: "St. Pierre and Miquelon",
      code: "PM",
    },
    {
      name: "Ukraine",
      code: "UA",
    },
    {
      name: "United States",
      code: "US",
    },
    {
      name: "Vanuatu",
      code: "VU",
    },
    {
      name: "Venezuela",
      code: "VE",
    },
    {
      name: "Western Sahara",
      code: "EH",
    },
    {
      name: "Zambia",
      code: "ZM",
    },
    {
      name: "Belize",
      code: "BZ",
    },
    {
      name: "Benin",
      code: "BJ",
    },
    {
      name: "Bermuda",
      code: "BM",
    },
    {
      name: "Bhutan",
      code: "BT",
    },
    {
      name: "Bolivia",
      code: "BO",
    },
    {
      name: "Bonaire, Sint Eustatius & Saba",
      code: "BQ",
    },
    {
      name: "Bosnia and Herzegovina",
      code: "BA",
    },
    {
      name: "Botswana",
      code: "BW",
    },
    {
      name: "Bouvet Island",
      code: "BV",
    },
    {
      name: "Brazil",
      code: "BR",
    },
    {
      name: "British Indian Ocean Territory",
      code: "IO",
    },
    {
      name: "Falkland Islands (Malvinas)",
      code: "FK",
    },
    {
      name: "Faroe Islands",
      code: "FO",
    },
    {
      name: "Fiji",
      code: "FJ",
    },
    {
      name: "Finland",
      code: "FI",
    },
    {
      name: "France",
      code: "FR",
    },
    {
      name: "French Guiana",
      code: "GF",
    },
    {
      name: "French Polynesia",
      code: "PF",
    },
    {
      name: "French Southern Territories",
      code: "TF",
    },
    {
      name: "Gabon",
      code: "GA",
    },
    {
      name: "Gambia",
      code: "GM",
    },
    {
      name: "Georgia",
      code: "GE",
    },
    {
      name: "Guernsey",
      code: "GG",
    },
    {
      name: "Japan",
      code: "JP",
    },
    {
      name: "Korea, Republic of",
      code: "KR",
    },
    {
      name: "Kuwait",
      code: "KW",
    },
    {
      name: "Kyrgyzstan",
      code: "KG",
    },
    {
      name: "Lao People’s Democratic Republic",
      code: "LA",
    },
    {
      name: "Latvia",
      code: "LV",
    },
    {
      name: "Lebanon",
      code: "LB",
    },
    {
      name: "Lesotho",
      code: "LS",
    },
    {
      name: "Liberia",
      code: "LR",
    },
    {
      name: "Libyan Arab Jamahiriya",
      code: "LY",
    },
    {
      name: "Liechtenstein",
      code: "LI",
    },
    {
      name: "Lithuania",
      code: "LT",
    },
    {
      name: "Luxembourg",
      code: "LU",
    },
    {
      name: "Macao",
      code: "MO",
    },
    {
      name: "Macedonia",
      code: "MK",
    },
    {
      name: "Madagascar",
      code: "MG",
    },
    {
      name: "New Zealand",
      code: "NZ",
    },
    {
      name: "Nicaragua",
      code: "NI",
    },
    {
      name: "Niger",
      code: "NE",
    },
    {
      name: "Nigeria",
      code: "NG",
    },
    {
      name: "Niue",
      code: "NU",
    },
    {
      name: "Norfolk Island",
      code: "NF",
    },
    {
      name: "Northern Mariana Islands ",
      code: "MP",
    },
    {
      name: "Norway",
      code: "NO",
    },
    {
      name: "Oman",
      code: "OM",
    },
    {
      name: "Pakistan",
      code: "PK",
    },
    {
      name: "Palau",
      code: "PW",
    },
    {
      name: "Palestinian Territory, Occupied",
      code: "PS",
    },
    {
      name: "Panama",
      code: "PA",
    },
    {
      name: "Papua New Guinea",
      code: "PG",
    },
    {
      name: "Paraguay",
      code: "PY",
    },
    {
      name: "Peru",
      code: "PE",
    },
    {
      name: "Philippines",
      code: "PH",
    },
    {
      name: "Pitcairn",
      code: "PN",
    },
    {
      name: "Poland",
      code: "PL",
    },
    {
      name: "Portugal",
      code: "PT",
    },
    {
      name: "Puerto Rico",
      code: "PR",
    },
    {
      name: "Qatar",
      code: "QA",
    },
    {
      name: "Reunion",
      code: "RE",
    },
    {
      name: "Romania",
      code: "RO",
    },
    {
      name: "New Caledonia",
      code: "NC",
    },
    {
      name: "St. Vincent and the Grenadines",
      code: "VC",
    },
    {
      name: "South Sudan",
      code: "SS",
    },
    {
      name: "Sudan",
      code: "SD",
    },
    {
      name: "Suriname",
      code: "SR",
    },
    {
      name: "Svalbard and Jan Mayen Islands",
      code: "SJ",
    },
    {
      name: "Swaziland",
      code: "SZ",
    },
    {
      name: "Sweden",
      code: "SE",
    },
    {
      name: "Switzerland",
      code: "CH",
    },
    {
      name: "Sierra Leone",
      code: "SL",
    },
    {
      name: "Taiwan",
      code: "TW",
    },
    {
      name: "Tajikistan",
      code: "TJ",
    },
    {
      name: "Tanzania, United Republic of",
      code: "TZ",
    },
    {
      name: "Thailand",
      code: "TH",
    },
    {
      name: "Timor-Leste",
      code: "TL",
    },
    {
      name: "Togo",
      code: "TG",
    },
    {
      name: "Tokelau",
      code: "TK",
    },
    {
      name: "Tonga",
      code: "TO",
    },
    {
      name: "Trinidad and Tobago",
      code: "TT",
    },
    {
      name: "Tunisia",
      code: "TN",
    },
    {
      name: "Turkey",
      code: "TR",
    },
    {
      name: "Turkmenistan",
      code: "TM",
    },
    {
      name: "Turks and Caicos Islands",
      code: "TC",
    },
    {
      name: "Tuvalu",
      code: "TV",
    },
    {
      name: "U.S. Minor Outlying Islands",
      code: "UM",
    },
    {
      name: "Uganda",
      code: "UG",
    },
    {
      name: "United Kingdom",
      code: "GB",
    },
    {
      name: "Uruguay",
      code: "UZ",
    },
    {
      name: "Vatican City State (Holy See)",
      code: "VA",
    },
    {
      name: "Wallis and Futuna Islands",
      code: "WF",
    },
    {
      name: "Yemen",
      code: "YE",
    },
    {
      name: "Zimbabwe",
      code: "ZW",
    },
  ];
  const significantOwnerCountryOptions = country.map((country) => ({
    value: `${country.code}:${country.name}`,
    title: `${country.code}:${country.name}`,
    key: `${country.code}:${country.name}`,
  }));

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return significantOwnerCountryOptions;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = significantOwnerCountryOptions.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AmexCountryOptions;
